// store/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';
 
// 初始状态
const initialState = {
  value: 0,
};
 
// 创建切片（包含状态和修改状态的方法）
const counterSlice = createSlice({
  name: 'counter', // 切片名称（用于区分不同状态）
  initialState,
  reducers: {
    // 定义增加计数的方法
    increment: (state:any) => {
      state.value += 1; // Redux Toolkit 内部自动处理了不可变性
    },
    // 定义减少计数的方法
    decrement: (state:any) => {
      state.value -= 1;
    },
  },
});
 
// 导出 action 方法（供组件调用）
export const { increment, decrement } = counterSlice.actions;
 
// 导出切片的 reducer（供 store 配置）
export default counterSlice.reducer;